module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/artillery-strike-elite.df40dfd8.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/artillery-strike-elite.png
// module id = 3701
// module chunks = 11